package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.Playstation2SimpleIcons: ImageVector
    get() {
        if (_playstation2SimpleIcons != null) {
            return _playstation2SimpleIcons!!
        }
        _playstation2SimpleIcons = Builder(name = "Playstation2SimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(7.46f, 13.78f)
                verticalLineToRelative(0.29f)
                horizontalLineToRelative(4.14f)
                verticalLineToRelative(-3.85f)
                horizontalLineToRelative(3.80f)
                lineTo(15.40f, 9.93f)
                horizontalLineToRelative(-4.12f)
                verticalLineToRelative(3.85f)
                close()
                moveTo(23.71f, 10.22f)
                verticalLineToRelative(1.62f)
                horizontalLineToRelative(-7.20f)
                verticalLineToRelative(2.23f)
                lineTo(24.0f, 14.07f)
                verticalLineToRelative(-0.29f)
                horizontalLineToRelative(-7.17f)
                verticalLineToRelative(-1.65f)
                lineTo(24.0f, 12.13f)
                lineTo(24.0f, 9.93f)
                horizontalLineToRelative(-7.49f)
                verticalLineToRelative(0.29f)
                close()
                moveTo(7.20f, 10.22f)
                verticalLineToRelative(1.62f)
                lineTo(0.0f, 11.84f)
                verticalLineToRelative(2.23f)
                horizontalLineToRelative(0.29f)
                verticalLineToRelative(-1.94f)
                lineTo(7.46f, 12.13f)
                lineTo(7.46f, 9.93f)
                lineTo(0.0f, 9.93f)
                verticalLineToRelative(0.29f)
                close()
            }
        }
        .build()
        return _playstation2SimpleIcons!!
    }

private var _playstation2SimpleIcons: ImageVector? = null
